import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-youduiqi",
  "use": "icon-youduiqi-usage",
  "viewBox": "0 0 1047 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1047 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-youduiqi\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 1024h1047.04v-113.664H0V1024z m349.184-227.328h698.368v-113.664H349.184v113.664zM0 568.832h1047.04V455.168H0v113.664z m349.184-227.328h698.368V227.328H349.184v114.176zM0 0v113.664h1047.04V0H0z\" p-id=\"10772\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol